import Serializable from "@/core/misc/mixins/Serializable";
import Currency from "@/domains/Currencies/Currency";
import Utils from "@/core/utils/Utils";
import DateSimple from "@/core/types/DateSimple";
import Sum from "@/core/types/Sum";
import Core from "@/core/Core";

/**
 * Счёт от контрагента
 */
class Invoice extends Serializable {
    public number: string;
    public date: DateSimple | null;
    public currencyCode: string | null;
    /** Объект валюты (для UI) */
    public currency: Currency | null;
    /** Полная сумма по счёту, в валюте счёта. Из неё выводится курс платежа */
    public sum: Sum | null;

    static fromServer(data: any, result = new Invoice()): Invoice {
        const invoice = super.fromServer(data, result);

        invoice.number = data.number;
        invoice.date = data.date ? DateSimple.fromServer(data.date) : null;
        invoice.currencyCode = data.currencyCode ?? null;
        invoice.sum = Core.utils.hydrate(data.sum, Sum.fromServer);

        if (invoice.currencyCode) {
            invoice.currency = Utils.money.getCurrencyByCode(invoice.currencyCode);
        }

        return invoice;
    }

    static fromNew(): Invoice {
        const result = new Invoice();

        result.number       = '';
        result.date         = null;
        result.currencyCode = null;
        result.currency     = null;
        result.sum          = null;

        return result;
    }

    get isEmpty(): boolean {
        return !this.number && !this.date;
    }

    get isValid(): boolean {
        return !!this.number && !!this.date && !!this.currencyCode;
    }

    static formatDiff(oldValue: Invoice | null, newValue: Invoice | null): string {
        if (!oldValue || !newValue) return '';

        let result = '';

        if (newValue.number && oldValue.number && newValue.number !== oldValue.number) {
            result += `номер счёта с ${oldValue.number} на ${newValue.number}; `;
        }

        if (newValue.date && oldValue.date && +newValue.date !== +oldValue.date) {
            result += `дата счёта с ${Core.utils.date.format(oldValue.date)} на ${Core.utils.date.format(newValue.date)}`;
        }

        return result;
    }
}

export default Invoice;